<template>
  <div class="modular">
    <div class="radiobox">
      <div class="radio">
        <el-radio v-model="radio" :label="1" @change="changeRadio">拓扑图</el-radio>
        <el-radio v-model="radio" :label="2" @change="changeRadio">表格</el-radio>
      </div>
    </div>
    <div v-show="radio === 1" v-loading="chartLoading">
      <topography :jsonData="topographyData" ></topography>
    </div>
    <div v-show="radio === 2" v-loading="chartLoading2">
      <el-table :data="dataList" border style="width: 100%;">
        <el-table-column type="index" align="center" width="50" fixed></el-table-column>
        <el-table-column prop="assetName" header-align="center" align="center" label="资产名称" width="180">
        </el-table-column>
        <el-table-column prop="assetIp" header-align="center" align="center" label="资产IP" width="180">
        </el-table-column>
        <el-table-column prop="securityZone" header-align="center" align="center" label="安全域id" width="180">
        </el-table-column>
        <el-table-column prop="assetTypeName" header-align="center" align="center" label="资产类型名称" width="180">
        </el-table-column>
        <el-table-column prop="logCount" header-align="center" align="center" label="本日日志">
        </el-table-column>
      </el-table>
      <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="page.pageIndex"
        :page-sizes="[10, 20, 50, 100]" :page-size="page.pageSize" :total="page.totalPage" layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import topography from './topography';
import { topologyArray } from '../selectOption';
export default {
  name: 'modularChild1',
  components: {
    topography
  },
  props: ['suId','socUserName', 'userId'],
  data () {
    return {
      chartLoading: false,
      chartLoading2: false,
      radio: 1,
      dataList: [
      ],
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0
      },      
      topographyData: [],
      limit: "",
      offset: "",
      ipOP: "",
      nameOP: "",
      sourceOP: "",
      typeOP: "",
      tagOP: "",
      orderField: "",
      username: "",
      edrStatsOP: ""
    }
  },
  methods: {
    sizeChangeHandle(size) {
      this.page.pageSize = size
      this.getData()
    },
    currentChangeHandle(current) {
      this.page.pageIndex = current
      this.getData()
    },     
    changeRadio() {
    },
    clearData() {
      let res = this.formatterTopographyData([])
      this.topographyData = res
    },
    getData(page,suId,socUserName) {
      if (page) {
        this.page.pageIndex = page
      }
      if (this.suId === null) return 
      if (suId === undefined) {
        suId = this.suId
      }
      if (socUserName === undefined) {
        socUserName = this.socUserName
      }
      this.chartLoading = true
      let params = {
        "suId": suId
      }
      this.$http.get(`/front/consumer/order/soc/topo/selectToPo/${suId}`)
        .then(data => {         
          if (data && data.status === 200 && data.data.code === 0) {
            let res = this.formatterTopographyData(data.data.data)
            this.topographyData = res
          } else {
            this.$message.error(data.result.msg)
          }
          this.chartLoading = false
        })
        .catch(() => {
          this.chartLoading = false
        })
      // // 假数据
      // let data1
      // // if (this.$store.getters.userInfo.userId == '25458') {
      //   data1 = {
      //     '10': [
      //       {
      //         'quantity': 2,
      //         'topoId': 1,
      //         'model': '通用PLC'
      //       }
      //     ],
      //     '20': [
      //       {
      //         'quantity': 1,
      //         'topoId': 43,
      //         'model': 'SUPCON ECS-200'
      //       }
      //     ],
      //     '30': [
      //       {
      //         'quantity': 1,
      //         'topoId': 31,
      //         'model': '通用PLC'
      //       }
      //     ],
      //     '40': []
      //   }
      // // }
      // // if (this.$store.getters.userInfo.userId == '25431') {
      // //   data1 = {
      // //     '10': [
      // //       {
      // //         'quantity': 3,
      // //         'topoId': 11,
      // //         'model': 'SUPCON ECS-700'
      // //       }
      // //     ],
      // //     '20': [
      // //       {
      // //         'quantity': 1,
      // //         'topoId': 13,
      // //         'model': 'SUPCON ECS-200'
      // //       }
      // //     ],
      // //     '30': [],
      // //     '40': []
      // //   }
      // // }
      // let res = this.formatterTopographyData(data1)
      // this.topographyData = res
      // this.chartLoading = false
      // // 假数据
      this.chartLoading2 = true
      let params2 = {
       "limit": this.page.pageSize,
      "offset": this.page.pageIndex-1,
        "ipOP": "",
      "nameOP": "",
    "sourceOP": "",
      "typeOP": "",
       "tagOP": "",
  "orderField": "",
    "username": socUserName,
  "edrStatsOP": ""
      }
      this.$http.post(`/front/consumer/order/soc/interface/queryUserAssetList`, params2)
        .then(data => {
          if (data && data.status === 200 && data.data.code === 0) {
            this.dataList = data.data.data.records
            this.page.totalPage = data.data.data.total            
          } else {
            this.dataList = []
            this.$message.error(data.result.msg)
          }
          this.chartLoading2 = false
        })
        .catch(() => {
          this.dataList = []
          this.chartLoading2 = false
        })
    },
    formatterTopographyData(data) {
      let res = []
      let topologyArraySort = topologyArray.sort(function(a, b) { return a.order - b.order })
      topologyArraySort.forEach(topologyArrayItem => {
        let code = topologyArrayItem.code
        let row = {
          id: code,
          title: topologyArrayItem.name,
          colItem: []
        }
        if (data[code] && data[code].length) {
          data[code].forEach(dataItem => {
            let imgs = []
            for (let index = 0; index < dataItem.quantity; index++) {
              imgs.push({
                id: new Date().getTime()
              })
            }
            row.colItem.push({
              ...dataItem,
              imgs: imgs,
              id: dataItem.topoId,
              title: dataItem.model,
              description: dataItem.quantity
            })
          })
        }
        res.push(row)
      })
      return res
    }
  },
  mounted () {
    this.getData()
  }
}
</script>

<style lang="scss" scoped>
.modular {
  position: relative;
  .radiobox {
    pointer-events: none;
    width: 100%;
    position: absolute;
    top: -30px;
    .radio {
      pointer-events: auto;
      width: 200px;
      margin: 0 auto;
    }
  }
}
</style>
